import { FC } from 'react';

type Props = {
	className?: string;
};

const PackageAddIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M9.19986 17.9998C8.54531 17.9998 7.92004 17.7356 6.66945 17.2074C3.55648 15.8924 2 15.2349 2 14.1289C2 13.8192 2 8.45155 2 6M9.19986 17.9998V9.48377M9.19986 17.9998C9.77969 17.9998 10.2342 17.7925 11.1998 17.3779M16.3997 6V9.19994'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M12.3999 14.3996H17.9998M15.1998 17.1995V11.5996'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M6.26065 8.15298L3.92374 7.02218C2.64124 6.40159 2 6.0913 2 5.59993C2 5.10856 2.64124 4.79827 3.92374 4.17768L6.26065 3.04688C7.70295 2.34896 8.42411 2 9.19986 2C9.9756 2 10.6968 2.34895 12.1391 3.04688L14.476 4.17768C15.7585 4.79827 16.3997 5.10856 16.3997 5.59993C16.3997 6.0913 15.7585 6.40159 14.476 7.02218L12.1391 8.15298C10.6968 8.85091 9.9756 9.19986 9.19986 9.19986C8.42411 9.19986 7.70295 8.85091 6.26065 8.15298Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M4.3999 10L5.99987 10.8'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M13.2 3.6001L5.2002 7.60002'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default PackageAddIcon;
